import { jsx as _jsx } from "react/jsx-runtime";
import { Card, User } from "@gravity-ui/uikit";
export var UserCard = function (props) {
    return (_jsx(Card, { className: "g-s__p_2", type: "action", view: "outlined", theme: "normal", onClick: props.onDetailsClick
            ? function () { return props.onDetailsClick(props.user.id); }
            : undefined, children: _jsx(User, { avatar: props.user.avatar
                ? { imgUrl: props.user.avatar.fileUrl }
                : { text: props.user.username, theme: "brand" }, name: props.user.username, size: "xl" }) }));
};
